
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Pubg </h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm pubg section-banner-bg-1">
    <div class="container">

        <div class="sec-title text-center">
            <h2> Pubg <span > Competition  2019 </span></h2>
        </div>
        <div class="widget_title inner-title mt-3">
            <h4>PUBG  COMPETITION</h4>
        </div>
        <div class="text-center">
            <iframe style="width:70%; height: 700px;" src="https://drive.google.com/file/d/1bDUxyD3x0QJYl1KlvHjughAM0LKSAzl5/preview"></iframe>
        </div>


    </div>
</section>
